import React, { useEffect, useState } from "react";
import "./GenerateApiKeys.css";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  generate_APIKey,
  deleteApiKey,
} from "../../../../features/organization/orgSlice";
import {
  Close,
  Code,
  ContentCopy,
  DeleteOutline,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import DynamicSnackbar from "../../../../Components/DynamicSnackbar";
import { getBotsbyUser } from "../../../../features/chatbots/chatbotSlice";
import APIKeySideBar from "./APIKeySideBar";
import { tableStyles } from "../../../../Constants/tableStyles";
import {
  deleteIconStyles,
  iconButtonStyles,
  primaryButtonStyles,
  textButtonStyles,
} from "../../../../Constants/buttonStyles";
import theme from "../../../../Constants/theme";
import { inputStyles } from "../../../../Constants/inputStyles";
import { dialogStyles } from "../../../../Constants/dialogStyles";

const GenerateApiKeys = ({ userId, setValue }) => {
  const { organization } = useSelector((state) => state.organization);
  const { user } = useSelector((state) => state.auth);
  const chatbot = useSelector((state) => state.chatbot);
  const dispatch = useDispatch();

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedName, setSelectedName] = useState("");
  const [open_sidebar, set_open_sidebar] = useState(false);
  const [selectedBot, setSelectedBot] = useState("");
  const [showFullKey, setShowFullKey] = useState({});
  const [deployedBotsList, setdeployedBotsList] = useState([]);

  const [items, setItems] = useState([]);

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "success", // success, error, warning, info
  });
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarState({ ...snackbarState, open: false });
  };

  useEffect(() => {
    const apiKeys = organization?.api_keys;

    setItems(apiKeys);
  }, [organization?.api_keys]);

  useEffect(() => {
    const check = organization?.bot.length > 0;
    // const orgId = organization?._id["$oid"];
    const userId = user?.user?._id?.["$oid"];
    const get_bots = async () => {
      // await dispatch(getBotbyOrg(orgId));
      const res = await dispatch(getBotsbyUser(userId));
    };

    if (check) {
      get_bots();
      if (chatbot?.chatbots?.combinations) {
        const filteredCombinations = chatbot?.chatbots?.combinations
          .filter((combination) => {
            const hasDefaultFlow =
              Object.keys(combination.default_flow).length > 0;
            const nameNotInItems = !items.some(
              (item) => item.name === combination.name
            );
            return hasDefaultFlow && nameNotInItems;
          })
          .map((combination) => {
            return {
              id: combination._id["$oid"],
              name: combination.name,
            };
          });
        setdeployedBotsList(filteredCombinations);
      }
    }
  }, [
    chatbot?.chatbots?.combinations,
    organization?.bot,
    user?.user?._id,
    items,
  ]);

  const handleOpenCreateKey = async () => {
    setOpenDialog(true);
  };

  const handleSelectChange = (event) => {
    setSelectedBot(event.target.value);
  };

  const generateKey = async () => {
    if (selectedBot) {
      const orgId = organization?._id["$oid"];
      const data = { bot_id: selectedBot.id, orgId };
      const res = await dispatch(generate_APIKey(data));
      if (res.meta.requestStatus === "fulfilled") {
        setSnackbarState({
          open: true,
          message: "API key successfully generated!",
          severity: "success",
        });
      } else {
        setSnackbarState({
          open: true,
          message: "API key was not generated successfully!",
          severity: "error",
        });
      }
    }
    setOpenDialog(false);
  };

  const deletekey = async (key) => {
    const res = await dispatch(deleteApiKey(key));
    if (res.meta.requestStatus === "fulfilled") {
      setSnackbarState({
        open: true,
        message: "API key deleted successfully!",
        severity: "success",
      });
    } else {
      setSnackbarState({
        open: true,
        message: "API key was not deleted!",
        severity: "error",
      });
    }
  };

  const toggleShowFullKey = (index) => {
    setShowFullKey((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const truncateKey = (key, showFull) => {
    return showFull ? key : "***************" + key.slice(-5);
  };

  const handleCopyToClipboard = (apiKey) => {
    navigator.clipboard.writeText(apiKey).then(
      () => {
        setSnackbarState({
          open: true,
          message: "API key copied to clipboard!",
          severity: "success",
        });
      },
      (err) => {
        setSnackbarState({
          open: true,
          message: "Failed to copy API key!",
          severity: "error",
        });
      }
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "flex-start",
        width: "100%",
        height: "80%",
        paddingX: "40px",
        // margin: "40px 0px",
        borderRadius: "10px",
        overflowX: "auto",
      }}
    >
      <Dialog
        PaperProps={{ sx: dialogStyles.dialogRoot }}
        fullWidth
        open={openDialog}
        onClose={() => setOpenDialog(false)}
      >
        <DialogTitle sx={dialogStyles.dialogTitle}>
          <IconButton
            onClick={() => setOpenDialog(false)}
            sx={dialogStyles.dialogCloseIcon}
          >
            <Close fontSize="small" />
          </IconButton>
          <Typography sx={dialogStyles.dialogTitleText}>
            Create API Key
          </Typography>
        </DialogTitle>
        <DialogContent dividers sx={dialogStyles.dialogContent}>
          {deployedBotsList.length > 0 ? (
            <FormControl fullWidth>
              <Select
                value={selectedBot || ""}
                onChange={handleSelectChange}
                variant="outlined"
                displayEmpty
                sx={inputStyles.select}
              >
                <MenuItem disabled value="">
                  Select LLM Apps
                </MenuItem>
                {deployedBotsList.map((bot) => (
                  <MenuItem key={bot.id} value={bot}>
                    {bot.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Typography sx={{ mt: 1, color: theme.textColors.dark.secondary }}>
              No New Bots Deployed
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={dialogStyles.dialogActions}>
          <Button onClick={() => setOpenDialog(false)} sx={textButtonStyles}>
            Cancel
          </Button>
          <Button
            onClick={generateKey}
            sx={primaryButtonStyles}
            disabled={!selectedBot || deployedBotsList.length < 1}
          >
            Generate API Key
          </Button>
        </DialogActions>
      </Dialog>

      <DynamicSnackbar
        open={snackbarState.open}
        message={snackbarState.message}
        severity={snackbarState.severity}
        onClose={handleCloseSnackbar}
      />

      {open_sidebar && (
        <APIKeySideBar
          open_sidebar={open_sidebar}
          set_open_sidebar={set_open_sidebar}
        />
      )}

      {items && (
        <TableContainer
          component={Paper}
          sx={{
            marginTop: "20px",
            ...tableStyles.tableContainer,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              py: 2,
              borderBottom: `1px solid ${theme.border.divider}`,
            }}
          >
            <Button onClick={handleOpenCreateKey} sx={primaryButtonStyles}>
              + Create new key
            </Button>

            <IconButton
              onClick={() => set_open_sidebar(true)}
              sx={iconButtonStyles}
            >
              <Code fontSize="small" />
            </IconButton>
          </Box>
          <Table>
            <TableHead sx={tableStyles.tableHead}>
              <TableRow>
                <TableCell
                  sx={{ ...tableStyles.tableHeaderCell, width: "100px" }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{ ...tableStyles.tableHeaderCell, width: "200px" }}
                  align="left"
                >
                  Description
                </TableCell>
                <TableCell sx={tableStyles.tableHeaderCell}>
                  Secret Key
                </TableCell>
                <TableCell
                  sx={{ ...tableStyles.tableHeaderCell, width: "120px" }}
                  align="center"
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {items.map((key, index) => (
                <TableRow
                  key={index}
                  sx={{
                    ...tableStyles.tableRow,
                    "&:last-child td": { borderBottom: "none" },
                  }}
                >
                  {/* Name */}
                  <TableCell sx={tableStyles.tableCell}>{key.name}</TableCell>

                  {/* Description */}
                  <TableCell sx={tableStyles.tableCell}>
                    {key.description}
                  </TableCell>

                  {/* Secret Key + Visibility Toggle */}
                  <TableCell sx={tableStyles.tableCell}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          wordBreak: "break-all",
                          fontSize: theme.typography.fontSize.xs,
                          color: theme.table.text.primary,
                        }}
                      >
                        {truncateKey(key.api_key, showFullKey[index])}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => toggleShowFullKey(index)}
                        sx={iconButtonStyles}
                      >
                        {showFullKey[index] ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </Box>
                  </TableCell>

                  {/* Actions */}
                  <TableCell sx={{ ...tableStyles.tableCell }} align="center">
                    <Box
                      sx={{ display: "flex", gap: 1, justifyContent: "center" }}
                    >
                      <Tooltip title="Copy key to clipboard">
                        <IconButton
                          onClick={() => handleCopyToClipboard(key.api_key)}
                          sx={iconButtonStyles}
                        >
                          <ContentCopy fontSize="small" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Delete Key">
                        <IconButton
                          onClick={() => deletekey(key.api_key)}
                          sx={deleteIconStyles}
                        >
                          <DeleteOutline fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default GenerateApiKeys;
